import type { AppConfig } from 'typings'

const defaultConfig: AppConfig = {
  SERVICE_URL: 'CF_API_HOST',
  BASENAME: '/cpra',
  RECAPTCHA_KEY: 'CF_RECAPTCHA_KEY',
  TRANSMIT_ENV: 'CF_TRANSMIT_ENV',
  CHANNEL_ID: 'SYFWEB'
}

const localConfig: AppConfig = {
  SERVICE_URL: process.env.REACT_APP_SERVICE_URL as string,
  BASENAME: '/',
  RECAPTCHA_KEY: process.env.REACT_APP_RECAPTCHA_SITE_KEY as string,
  TRANSMIT_ENV: process.env.REACT_APP_TRANSMIT_ENV as string,
  CHANNEL_ID: 'SYFWEB'
}

export default process.env.NODE_ENV === 'development'
  ? localConfig
  : defaultConfig
